module.exports = __webpack_public_path__ + "img/cargo-wagon-3.fa58b95f.png";